import React from 'react';

import { isNotEmptyArray } from '@travel/utils';

import TaxFee from 'components/TaxFee';

import { Translate } from 'core/translate';
import { TaxAndFee } from 'ProviderRatePlan-Types';

type Props = {
  /** custom classnames */
  className?: string;
  excludedFeeRemarkClassName?: string;
  titleClassName?: string;
  /** Array of include taxes */
  includeTaxes?: Array<TaxAndFee>;
  /** Array of exclude taxes */
  excludeTaxes?: Array<TaxAndFee>;
  shouldHideTitle?: boolean;
};

function TaxAndFeeSection(props: Props) {
  if (!isNotEmptyArray(props.includeTaxes) && !isNotEmptyArray(props.excludeTaxes)) {
    return null;
  }

  return (
    <div data-testid="taxAndFeeSection-wrapper" className={props.className}>
      {!props.shouldHideTitle && (
        <h3 className={props.titleClassName}>
          <Translate id="Common_Price_Details.Taxes_Fees.Title" />
        </h3>
      )}

      <TaxFee taxFee={props.includeTaxes || []} />
      <TaxFee taxFee={props.excludeTaxes || []} isExclude />
      {isNotEmptyArray(props.excludeTaxes) && (
        <p className={props.excludedFeeRemarkClassName}>
          * <Translate id="Common_Price_Details.Taxes_Fees.Disclaimer" />
        </p>
      )}
    </div>
  );
}

export default TaxAndFeeSection;
